import React from "react";
import { Link } from "react-router-dom";
import { FaUserPlus, FaUsers } from "react-icons/fa";
import { motion } from "framer-motion";

const CompVendedoresMenu = () => {
  return (
    <div className="flex-grow flex items-center justify-center mt-16">
      <div className="w-full max-w-3xl p-6">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="space-y-6"
        >
          {/* Título */}
          <div className="flex items-center justify-center mb-6">
            <h2 className="text-4xl font-bold text-center text-gray-700">
              Gestión de Vendedores
            </h2>
          </div>

          {/* Añadir Vendedor */}
          <Link
            to="/vendedores/crear"
            className="block bg-yellow-500 rounded-lg py-4 px-6 text-white text-center shadow-md hover:bg-yellow-600 transition transform hover:scale-105"
          >
            <div className="flex items-center justify-center">
              <FaUserPlus className="text-2xl mr-3" />
              <span className="text-lg font-semibold">Añadir Vendedor</span>
            </div>
          </Link>

          {/* Ver Todos los Vendedores */}
          <Link
            to="/vendedores/todos"
            className="block bg-orange-500 rounded-lg py-4 px-6 text-white text-center shadow-md hover:bg-orange-600 transition transform hover:scale-105"
          >
            <div className="flex items-center justify-center">
              <FaUsers className="text-2xl mr-3" />
              <span className="text-lg font-semibold">Ver Todos los Vendedores</span>
            </div>
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default CompVendedoresMenu;
